module.exports = __webpack_public_path__ + "img/share-07.23a646e5.jpg";